"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromotionTemplateSchema = exports.TemplateCategorySchema = exports.CouponPromotionSchema = exports.PromotionSchema = void 0;
const zod_1 = require("zod");
const __1 = require("..");
const base_promotion_1 = require("./base-promotion");
exports.PromotionSchema = base_promotion_1.BasePromotionSchema.extend({
    items: __1.ItemSchema.extend({
        baseVariant: __1.ItemVariantSchema.partial(),
        additionalVariants: __1.ItemVariantSchema.partial().array().optional(),
    })
        .partial()
        .required({ id: true })
        .array()
        .optional(),
});
exports.CouponPromotionSchema = exports.PromotionSchema.pick({
    id: true,
    createdAt: true,
    updatedAt: true,
    startsAt: true,
    endsAt: true,
    deactivatedAt: true,
    applications: true,
    type: true,
    code: true,
    store: true,
    status: true,
    promotionPercent: true,
    promotionPrice: true,
    usageCount: true,
}).required({
    code: true,
});
exports.TemplateCategorySchema = __1.BaseSchema.extend({
    name: __1.ShortStringSchema,
    index: zod_1.z.number().min(1),
    status: zod_1.z.nativeEnum(__1.TemplateCategoryStatus).default(__1.TemplateCategoryStatus.Active),
    templateActiveCount: zod_1.z.number().default(0),
    templateCount: zod_1.z.number().default(0),
});
exports.PromotionTemplateSchema = __1.BaseSchema.extend({
    category: exports.TemplateCategorySchema.partial().required({ id: true }),
    status: zod_1.z.nativeEnum(__1.PromotionTemplateStatus).default(__1.PromotionTemplateStatus.Active),
    squareTemplate: zod_1.z.string(),
    rectangularTemplate: zod_1.z.string(),
    thumbUrl: zod_1.z.string().url(),
    index: zod_1.z.number().optional(),
});
//# sourceMappingURL=promotion.js.map